import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { sanitizeHtml } from 'src/app/shared/utils/safe-html.util';

interface TemplatePreviewData {
    title: string;
    content: string;
    variables?: Record<string, string>;
    previewMode: boolean;
}

@Component({
    selector: 'app-template-preview',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule],
    template: `
    <div class="template-preview-container">
      <h2 mat-dialog-title>{{data.title}}</h2>
      
      <div mat-dialog-content>
        <div class="preview-content" [innerHTML]="safeHtml"></div>
      </div>
      
      <div mat-dialog-actions align="end">
        <button mat-button (click)="onClose()">Fechar</button>
      </div>
    </div>
  `,
    styles: [`
    .template-preview-container 
      padding: 0
      font-family: Arial, sans-serif
    
    
    h2 
      margin-top: 0
      padding: 16px
      background-color: #f5f5f5
      border-bottom: 1px solid #e0e0e0
    
    
    .preview-content 
      padding: 16px
      min-height: 300px
      max-height: 70vh
      overflow-y: auto
      background-color: white
      border: 1px solid #e0e0e0
      border-radius: 4px
      margin-bottom: 16px
    
  `]
})
export class TemplatePreviewComponent implements OnInit {
    safeHtml: string;

    constructor(
        public dialogRef: MatDialogRef<TemplatePreviewComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TemplatePreviewData,
        private sanitizer: DomSanitizer
    ) {
        // Sanitizar o HTML para evitar problemas de segurança
        this.safeHtml = sanitizeHtml(this.sanitizer, data.content);
    }

    ngOnInit(): void {
        // Adicionar estilo para garantir que o conteúdo seja exibido corretamente
        const styleElement = document.createElement('style');
        styleElement.textContent = `
      .preview-content {
        font-family: Arial, sans-serif;
        line-height: 1.6;
        color: #333;
      }
      
      .preview-content h1, 
      .preview-content h2, 
      .preview-content h3 {
        color: #2c3e50;
        margin-top: 1em;
        margin-bottom: 0.5em;
      }
      
      .preview-content table {
        border-collapse: collapse;
        width: 100%;
        margin: 1em 0;
      }
      
      .preview-content table, 
      .preview-content th, 
      .preview-content td {
        border: 1px solid #ddd;
      }
      
      .preview-content th, 
      .preview-content td {
        padding: 8px;
        text-align: left;
      }
      
      .preview-content th {
        background-color: #f2f2f2;
      }
    `;
        document.head.appendChild(styleElement);
    }

    onClose(): void {
        this.dialogRef.close();
    }
} 